import { Trans } from '@lyearn/i18n';
import { AddMenuQuiz, CheckmarkCircleOutlineLegacy } from '@lyearn/icons';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';

import InlinePlayerToggle from './components/InlinePlayerToggle';

const quizExtension = createReactExtension({
  name: 'ly__quiz',
  attrs: {
    contentId: {
      default: null,
    },
    inlinePlayer: {
      default: false,
    },
  },
  Component: (props) => {
    const { attrs, ...rest } = props;
    const Component =
      require('@/modules/corporate/modules/course/components/QuizCardContainer').default;
    return <Component {...attrs} {...rest} />;
  },
  menuItem: [
    {
      name: 'ly__quiz',
      title: <Trans i18nKey="Common:ResourceType.Quiz" />,
      icon: CheckmarkCircleOutlineLegacy,
      addMenuIcon: AddMenuQuiz,
      addMenuItemType: addMenuItemType.contents,
      description: <Trans i18nKey="Admin:Contents.QuizDescription" />,
      searchWords: ['quiz', 'assessments'],
    },
  ],
  advancedMenuItem: {
    name: 'ly__quiz',
    title: 'Quiz Settings',
    components: [
      {
        name: 'inline_player',
        component: InlinePlayerToggle,
        isEnabled: (node) => !!node.attrs.contentId,
      },
    ],
  },
  performanceType: PerformanceType.BLOCK_BASED,
});

export default quizExtension;
